webpackJsonp([146304318568534],{

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formik = __webpack_require__(10);
	
	var _yup = __webpack_require__(13);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _Alert = __webpack_require__(14);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Input = __webpack_require__(9);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _RadioGroup = __webpack_require__(16);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Datetime = __webpack_require__(18);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormLeadgen = function (_Component) {
	  _inherits(FormLeadgen, _Component);
	
	  function FormLeadgen(props) {
	    _classCallCheck(this, FormLeadgen);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      formState: null,
	      showCalForm: false,
	      firstname: "",
	      lastname: "",
	      email: "",
	      phone: "",
	      market1: "",
	      market2: "",
	      market3: "",
	      company: "",
	      calEmbed: ""
	    };
	    _this.showCalForm = _this.showCalForm.bind(_this);
	    _this.setFormVal = _this.setFormVal.bind(_this);
	    return _this;
	  }
	
	  FormLeadgen.prototype.showCalForm = function showCalForm(e) {
	    console.log("showcalform");
	    console.log(e.target);
	    if (e.target.checked) {
	      var interestedMarkets = "Interested markets: " + this.state.market1 + " - " + this.state.market2 + " - " + this.state.market3;
	      var thisCompany = "Company: " + this.state.company;
	      var eventDesc = encodeURIComponent(thisCompany + ", " + interestedMarkets);
	      var tempCode = "\n      <!-- Calendly inline widget begin -->\n      <iframe style=\"height:740px\" src=\"https://calendly.com/estsean/15min-1?embed_domain=&amp;embed_type=Inline&amp;name=";
	      tempCode += encodeURIComponent(this.state.firstname + " " + this.state.lastname);
	      tempCode += "&amp;email=";
	      tempCode += encodeURIComponent(this.state.email);
	      tempCode += "&amp;a1=";
	      tempCode += this.state.phone.replace(/\D/g, "");
	      tempCode += "&amp;a2=";
	      tempCode += eventDesc;
	      tempCode += "\" width=\"100%\" height=\"100%\" frameborder=\"0\"></iframe>\n          <!--Calendly inline widget end-- >\n      ";
	      this.setState({ calEmbed: tempCode });
	      this.setState({ showCalForm: true });
	    } else {
	      this.setState({ showCalForm: false });
	    }
	  };
	
	  FormLeadgen.prototype.setFormVal = function setFormVal(e) {
	    console.log(e.target.name);
	    var tempObj = {};
	    tempObj[e.target.name] = e.target.value;
	    this.setState(tempObj);
	  };
	
	  FormLeadgen.prototype.render = function render() {
	    var _this2 = this;
	
	    var formState = this.state.formState;
	    var _props = this.props,
	        classes = _props.classes,
	        className = _props.className;
	
	    var valid = function valid(current) {
	      return current.day() !== 0 && current.day() !== 6;
	    };
	    var renderDay = function renderDay(props, currentDate, selectedDate) {
	      if (currentDate.month() == (0, _moment2.default)().month()) {
	        if (currentDate.date() < (0, _moment2.default)().date()) {
	          if (props.className == "rdtDay") {
	            props.className = "rdtDay rdtDisabled";
	          }
	        }
	      }
	      if (currentDate.month() < (0, _moment2.default)().month()) {
	        props.className = "rdtDay rdtDisabled";
	      }
	      return _react2.default.createElement(
	        "td",
	        props,
	        currentDate.date()
	      );
	    };
	    if (formState === "success") {
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            maxWidth: "600px",
	            textAlign: "center",
	            margin: "24px auto"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading3", gutterBottom: true },
	            "Got it!"
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading5", gutterTop: true },
	            "We'll check availability & reach out to you asap via email or telephone.",
	            _react2.default.createElement("br", null)
	          )
	        )
	      );
	    } else if (formState === "error") {
	      return _react2.default.createElement(
	        "div",
	        { style: { maxWidth: "400px", margin: "24px auto" } },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "error" },
	          "An error occurred."
	        )
	      );
	    }
	    return _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)(classes.root, className) },
	      _react2.default.createElement(_formik.Formik, {
	        initialValues: {
	          firstname: "",
	          lastname: "",
	          company: "",
	          email: "",
	          phone: "",
	          market1: "",
	          market2: "",
	          market3: "",
	          role: "",
	          form: "leadgen_formNew",
	          list: 57292
	        },
	        validationSchema: function validationSchema() {
	          return Yup.object().shape({
	            firstname: Yup.string().required("First name is required"),
	            lastname: Yup.string().required("Last name is required"),
	            company: Yup.string(),
	            email: Yup.string().email("Invalid email address").required("Email is required"),
	            phone: Yup.string().required("Phone is required"),
	            mls_number: Yup.string()
	          });
	        },
	        onSubmit: function onSubmit(values, _ref) {
	          var setSubmitting = _ref.setSubmitting;
	
	          //console.log(values.meetingdate);
	          var meeting_request = "";
	          Object.keys(values).forEach(function (key, index) {
	            // key: the name of the object key
	            // index: the ordinal position of the key within the object
	            if (key == "meetingdate") {
	              if (typeof values.meetingdate.format === "function") {
	                meeting_request = values.meetingdate.format("YYYY-MM-DD") + "T" + values.meetingtime.replace(" (EDT)", "") + "-04:00";
	              }
	            }
	          });
	          var body = _extends({}, values, {
	            demo_request_date: meeting_request,
	            notes: "Interested Markets: " + values.market1 + "," + values.market2 + "," + values.market3,
	            utm_campaign: window.utm_tags ? window.utm_tags.campaign : "",
	            utm_source: window.utm_tags ? window.utm_tags.source : "",
	            utm_medium: window.utm_tags ? window.utm_tags.medium : "",
	            utm_term: window.utm_tags ? window.utm_tags.term : ""
	          });
	          return fetch("https://hooks.zapier.com/hooks/catch/4496703/3uy9gh0/", {
	            method: "POST",
	            body: JSON.stringify(body)
	          }).then(function (response) {
	            return response.json();
	          }).then(function (res) {
	            if (res.status === "success") {
	              _this2.setState({ formState: "success" });
	              dataLayer.push({ event: "form-success" });
	              if (window.fbq) {
	                window.fbq("track", "Lead");
	              }
	              if (window.gtag) {
	                window.gtag("event", "conversion", {
	                  send_to: "AW-980447970/2_aHCOnsjo8BEOLlwdMD"
	                });
	              }
	              if (window.ga) {
	                window.ga("send", "event", "form", "form_completed", "leadgen");
	              }
	            } else {
	              _this2.setState({ formState: "error" });
	            }
	          }).catch(function (err) {
	            _this2.setState({ formState: "error" });
	          });
	        },
	        render: function render(_ref2) {
	          var values = _ref2.values,
	              isSubmitting = _ref2.isSubmitting,
	              handleBlur = _ref2.handleBlur,
	              handleChange = _ref2.handleChange;
	          return _react2.default.createElement(
	            _formik.Form,
	            { noValidate: true },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  maxWidth: "500px",
	                  marginLeft: "auto",
	                  marginRight: "auto"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: classes.topRow },
	                _react2.default.createElement(_formik.Field, {
	                  id: "firstname",
	                  name: "firstname",
	                  label: "First Name",
	                  component: _Input2.default,
	                  className: classes.field,
	                  onBlur: _this2.setFormVal
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "lastname",
	                  name: "lastname",
	                  label: "Last Name",
	                  component: _Input2.default,
	                  className: classes.field,
	                  onBlur: _this2.setFormVal
	                })
	              ),
	              _react2.default.createElement(_formik.Field, {
	                id: "email",
	                name: "email",
	                label: "Email",
	                component: _Input2.default,
	                className: classes.field,
	                onBlur: _this2.setFormVal
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "phone",
	                name: "phone",
	                label: "Phone",
	                component: _Input2.default,
	                className: classes.field,
	                type: "tel",
	                onBlur: _this2.setFormVal
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "company",
	                name: "company",
	                label: "Affiliation (optional)",
	                component: _Input2.default,
	                className: classes.field,
	                onBlur: _this2.setFormVal
	              }),
	              _react2.default.createElement(
	                "div",
	                { style: { width: "100%", textAlign: "center" } },
	                "What are your top 3 markets of interest? (optional)"
	              ),
	              _react2.default.createElement(_formik.Field, {
	                id: "market1",
	                name: "market1",
	                label: "City/State",
	                component: _Input2.default,
	                className: classes.field,
	                onBlur: _this2.setFormVal
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "market2",
	                name: "market2",
	                label: "City/State",
	                component: _Input2.default,
	                className: classes.field,
	                onBlur: _this2.setFormVal
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "market3",
	                name: "market3",
	                label: "City/State",
	                component: _Input2.default,
	                className: classes.field,
	                onBlur: _this2.setFormVal
	              }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    textAlign: "left",
	                    fontSize: "14px",
	                    lineHeight: "19px"
	                  }
	                },
	                _react2.default.createElement(_formik.Field, {
	                  id: "role",
	                  name: "role",
	                  label: "I am:",
	                  component: _RadioGroup2.default,
	                  display: "inline",
	                  items: [{
	                    label: "An Existing Client",
	                    value: "Existing Client"
	                  }, {
	                    label: "An Agent",
	                    value: "Agent"
	                  }, {
	                    label: "A Broker/Owner",
	                    value: "Broker/Owner"
	                  }, {
	                    label: "Other (please specify)",
	                    value: "Other"
	                  }],
	                  className: classes.field
	                }),
	                values.role === "Other" && _react2.default.createElement(_formik.Field, {
	                  id: "roleOther",
	                  name: "roleOther",
	                  label: "Other",
	                  component: _Input2.default,
	                  className: classes.field,
	                  autoFocus: true
	                })
	              ),
	              "Schedule 15 minutes with a Lead Generation Specialist:",
	              _react2.default.createElement(_formik.Field, {
	                id: "demorequest",
	                name: "demorequest",
	                type: "checkbox",
	                value: "yes",
	                className: classes.checkfield
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "submit",
	                  className: classes.signUpBtn,
	                  disabled: isSubmitting
	                },
	                "Check Availability"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: "11px", lineHeight: "16px" } },
	              "*excludes Elite Pro & Brokerage solutions",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "By submitting this form, you are requesting to be contacted by a member of the Elevate Sales Team at the details provided via text, email or call (may involve automated or pre-recorded means). You may revoke this consent through any reasonable means.",
	              _react2.default.createElement("br", null),
	              "Existing subscribers seeking support, please visit the",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://support.tryelevate.com/s/ " },
	                "Elevate Help Center"
	              ),
	              "."
	            )
	          );
	        }
	      })
	    );
	  };
	
	  return FormLeadgen;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      maxWidth: "700px",
	      margin: "0 auto",
	      textAlign: "center"
	    },
	    link: {
	      color: "inherit"
	    },
	    rdtDay: {
	      backgroundColor: "#CCC"
	    },
	    field: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "50px",
	      fontWeight: "600"
	    },
	    selectfield: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "40px"
	    },
	    selectlabel: {
	      width: "100%",
	      color: "#888f96",
	      display: "flex",
	      fontSize: "14px",
	      alignItems: "center",
	      lineHeight: "18px",
	      fontWeight: "700",
	      marginBottom: "4px"
	    },
	    topRow: {
	      display: "flex",
	      flexDirection: "row",
	      justifyContent: "space-between",
	      "& > * + *": {
	        marginLeft: "12px"
	      }
	    },
	    signUpBtn: {
	      width: "100%",
	      fontSize: "20px",
	      lineHeight: "26px",
	      fontWeight: "600",
	      color: "#FFF",
	      backgroundColor: theme.colors.secondary,
	      borderRadius: "6px",
	      padding: "12px",
	      marginTop: "30px",
	      marginBottom: "30px",
	      textDecoration: "none"
	    },
	    headingSmall: {
	      fontSize: "20px",
	      textTransform: "uppercase",
	      fontWeight: "600",
	      color: "#55c3ba",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingLarge: {
	      fontSize: "40px",
	      textTransform: "uppercase",
	      fontWeight: "700",
	      color: "#55c3ba",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingText: {
	      fontSize: "20px",
	      fontWeight: "700",
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "1.4em"
	    }
	  };
	})(FormLeadgen);
	module.exports = exports["default"];

/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/doubledown.f50b25d3.png";

/***/ }),

/***/ 3145:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/leads_bottom_image.e4a19df5.jpg";

/***/ }),

/***/ 1699:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _FormLeadgen = __webpack_require__(1559);
	
	var _FormLeadgen2 = _interopRequireDefault(_FormLeadgen);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _doubledown = __webpack_require__(1342);
	
	var _doubledown2 = _interopRequireDefault(_doubledown);
	
	var _leads_top_image = __webpack_require__(110);
	
	var _leads_top_image2 = _interopRequireDefault(_leads_top_image);
	
	var _leads_bottom_image = __webpack_require__(3145);
	
	var _leads_bottom_image2 = _interopRequireDefault(_leads_bottom_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dms = function Dms(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      data = _ref.data,
	      tags = _ref.tags;
	
	  var postNode = {
	    title: "Lead Generation - " + _siteConfig2.default.siteTitle
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Lead Generation - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "leadgen", customTitle: true }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: "900px", backgroundColor: "#ece8ea", marginRight: "auto", marginLeft: "auto", paddingTop: "20px", textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { style: { padding: "40px", textAlign: "center" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.heading, style: { color: "#52B1AD" } },
	              "LIMITED AVAILABILITY ON",
	              _react2.default.createElement("br", null),
	              "EXCLUSIVE BUYER / SELLER LEADS"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subHeading, style: { color: "#52B1AD" } },
	              "EXCLUSIVE LEADS IN MARKETS ACROSS THE U.S."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.centersubtext, style: { paddingLeft: "22px", paddingRight: "22px" } },
	              "First Come. First Served.",
	              _react2.default.createElement("br", null),
	              "Check availability today."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { paddingLeft: "22px", paddingRight: "22px" } },
	            _react2.default.createElement(_FormLeadgen2.default, null)
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("img", { src: _leads_bottom_image2.default, style: { width: "100%" } })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _centersubtext;
	
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      padding: "0 8px",
	      margin: "20px auto"
	    },
	    heading: {
	      fontSize: "30px",
	      fontWeight: "700",
	      letterSpacing: ".14px",
	      color: "#2E2E35",
	      textAlign: "center",
	      marginBottom: "12px"
	    },
	    centersubtext: (_centersubtext = {
	      color: "#5A5B5C",
	      fontWeight: "700",
	      fontSize: "16px",
	      letterSpacing: ".25px",
	      lineHeight: "1.6",
	      marginbottom: "20px",
	      textAlign: "center"
	
	    }, _centersubtext[theme.breakpoints[900]] = {
	      fontSize: "16px"
	    }, _centersubtext),
	
	    subHeading: {
	      fontSize: "18px",
	      fontWeight: "700",
	      lineHeight: "28px",
	      letterSpacing: ".08px",
	      textAlign: "center",
	      margin: "0 auto 36px"
	    },
	    landingHeaderStyle: {
	      textAlign: "center",
	      marginBottom: "30px"
	    }
	  };
	})(Dms);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-leadgen-js-e2eb38c6f5eca9c7146d.js